export type { IStore } from "./interfaces";
export { useGetStores } from "./useGetStores";
